import { Tabs } from 'antd'
import React from 'react'
import { t } from 'i18next'
import EventsTab from './EventsTab'
import FeedbackForm from './FeedbackForm'
import SMSPanel from '../SMSPanel/SMSPanel'
import AdminAppointmentForm from './AdminAppointmentForm'
import LogsPanel from './LogsPanel'

export default function AdminAppointmentCardTabs ({ form, appointment, setAppointment, loading, setLoading, setIsDirty }) {
  return (
    <>
      { appointment &&
        <Tabs style={{ marginBottom: '1em' }}
          defaultActiveKey='form'
          items={[
            {
              label: t('Admin.AdminAppointmentPage.tab.form'),
              key: 'form',
              children: <AdminAppointmentForm form={form} appointment={appointment} setAppointment={setAppointment} setLoading={setLoading} loading={loading} />
            },
            {
              label: t('Admin.AdminAppointmentPage.tab.log'),
              key: 'log',
              children: <LogsPanel logs={appointment.logs} date={appointment.begin_date} />
            },
            {
              label: t('Admin.AdminAppointmentPage.tab.sms'),
              key: 'sms',
              children: <SMSPanel owner={appointment} ownerType="appointments" setOwner={setAppointment} />
            },
            {
              label: t('Admin.AdminAppointmentPage.tab.events'),
              key: 'events',
              children: <EventsTab appointment={appointment} setLoading={setLoading} />
            },
            {
              label: t('Admin.AdminAppointmentPage.tab.feedback'),
              key: 'feedback',
              children: <FeedbackForm appointment={appointment} setLoading={setLoading} setAppointment={setAppointment} setIsDirty={setIsDirty} />
            }
          ]}
        />
      }
    </>
  )
}
